<template>
  <div>

    <el-card>
      <div slot="header">
        <span>设备管理</span>
      </div>
      <el-row :gutter="10">
        <el-col :span="5">
          <div class="box-card" style="min-height: 480px" id="filter">
            <div style="margin: 10px 0" class="title-font">园区</div>
            <el-select v-model="parkId" @change="landSearch">
              <el-option
                v-for="item in parkOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-divider></el-divider>
            <div style="margin: 10px 0;" class="title-font">园区气象站</div>
            <div v-if="!weatherEditor" style="display: flex;justify-content: space-between;padding: 6px">
              <span style="padding-top: 1px" class="content-font">{{equipSn.weatherSn | weatherSnFormat }}</span>
              <el-button v-if="equipSn.weatherSn==''" type="primary" size="mini" @click="weatherSet">设置</el-button>
              <el-button v-else type="primary" size="mini" @click="weatherUpdate">修改</el-button>
            </div>
            <div v-else style="display: flex;justify-content: space-between">
              <el-input type="mini" v-model="weatherSn"></el-input>
              <div style="width: 100px;padding: 5px">
                <el-button type="primary" size="mini" circle icon="el-icon-check" @click="weatherSure"></el-button>
                <el-button type="warning" size="mini" circle icon="el-icon-close" @click="weatherCancel"></el-button>
              </div>
            </div>
            <div style="margin: 10px 0" class="title-font">水肥机</div>
            <div v-if="!irrigationEditor" style="display: flex;justify-content: space-between;padding: 6px">
              <span  style="padding-top: 1px" class="content-font">{{ equipSn.irrigationSn |irrigationSnFormat}}</span>
              <el-button v-if="equipSn.irrigationSn==''" type="primary" size="mini" @click="irrigatSet">设置</el-button>
              <el-button v-else type="primary" size="mini" @click="irrigatUpdate">修改</el-button>
            </div>
            <div v-else style="display: flex;justify-content: space-between">
              <el-input type="mini" v-model="irrigationSn"></el-input>
              <div style="width: 100px;padding: 5px">
                <el-button type="primary" size="mini" circle icon="el-icon-check" @click="irrigatSure"></el-button>
                <el-button type="warning" size="mini" circle icon="el-icon-close" @click="irrigatCancel"></el-button>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="box-card" style="min-height: 480px">
            <el-row>
              <el-col :span="23">
                <div style="margin: 10px 0" class="title-font">地块</div>
              </el-col>
              <el-col :span="1">
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-empty v-if="landOption.length==0" description="暂无地块"></el-empty>
              <div v-else>
                <el-col :span="6" v-for="(e, index) in landOption" :key="index" style="margin-bottom: 8px">
                  <equip-card :land="e" :irrigationSnOfland="equipSn.irrigationSn" />
                </el-col>
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import EquipCard from './EquipCard.vue'
import { getDeviceInfoByPark ,setParkDeviceSn,updateParkDeviceSn} from '@/api/equip.js'
import { getParksInEnterprise,getPark } from '@/api/park2.js'
import { getLandInPark } from '@/api/land2.js'
import Map from "../../meta/land/locate-map";
export default {
  name: 'EquipIndex',
  components: { EquipCard },
  data() {
    return {
      id: undefined,
      keyword: null,
      lands: [0, 923, 235, 423],
      type: 0,
      equips: [],
      parkId: '',
      parkOption: [],
      landOption:[],
      weatherEditor:false,
      weatherSn:'',
      irrigationEditor:false,
      irrigationSn:'',
      weatherNewSet:false,
      irrigationSnSet:false,
      equipSn:{
        irrId:'',
        irrigationSn:'',
        weatherId:'',
        weatherSn:''
      }
    }
  },
  filters:{
    weatherSnFormat(val) {
      if(val=="") {
        return '未设置'
      }else{
        return  val
      }
    },
    irrigationSnFormat(val) {
      if(val=="") {
        return '未设置'
      }else{
        return  val
      }
    }
  },
  mounted() {
    getParksInEnterprise(this.$store.getters.currentEnterprise.id).then(
      (data) => {
        console.log(data)
        this.parkOption = data.data
        this.parkId=this.parkOption[0].id
        this.parkDiviceInfoget()
        this.$nextTick(()=>{
          this.landSearch()
        })
        // this.equipsDataGet()
      }
    )
  },

  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
  methods: {
    parkDiviceInfoget() {
      getDeviceInfoByPark(this.parkId).then(data=>{
        console.log('设备',data)
        // this.weatherSn=data.data
        if(data.data.length===0){
          this.equipSn.irrigationSn=""
          this.equipSn.weatherSn=""
          return
        }
        let irrigateObj=data.data.find(item=>item.deviceType=='irrigate')
        let house=data.data.find(item=>item.deviceType=='meteo')
        console.log(irrigateObj)
        if(irrigateObj) {
          this.irrigationSn=irrigateObj.sn
          this.equipSn.irrigationSn=irrigateObj.sn
          this.equipSn.irrId=irrigateObj.id
        }else{
          this.equipSn.irrigationSn=""
        }
        if(house) {
          this.equipSn.weatherSn=house.sn
          this.weatherSn=house.sn
          this.equipSn.weatherId=house.id
        }else{
          this.equipSn.weatherSn=""
        }
      })
    },
    weatherUpdate() {
      this.weatherSn=this.equipSn.weatherSn
      this.weatherNewSet=false
      this.weatherEditor=!this.weatherEditor
    },
    weatherSet() {
      this.weatherSn=this.equipSn.weatherSn
      this.weatherNewSet=true
      this.weatherEditor=!this.weatherEditor
    },
    weatherSure() {
      this.weatherEditor=false
      let option={}
      option.deviceType='meteo'
      option.parkId=this.parkId
      option.sn=this.weatherSn
      option.id= this.equipSn.weatherId
      if(this.weatherNewSet){
        console.log('添加设备参数',option)
        setParkDeviceSn(option).then(data=>{
          this.parkDiviceInfoget()
          this.$message.success(data.message)
        })
      }else{
        updateParkDeviceSn(option).then(data=>{
          this.parkDiviceInfoget()
          this.$message.success(data.message)
        })
      }
    },
    weatherCancel() {
      this.weatherEditor=false
    },
    landSearch() {
      getLandInPark(this.parkId).then((data) => {
        if (data) {
          console.log(data)
          this.landOption=data.data
        }
        this.parkDiviceInfoget()
      })
    },
    irrigatSet() {
      console.log('水肥机灌溉')
      this.irrigationSnSet=true
      this.irrigationEditor=true
      this.irrigationSn=this.equipSn.irrigationSn
    },
    irrigatUpdate() {
      this.irrigationSnSet=false
      this.irrigationEditor=true
      this.irrigationSn=this.equipSn.irrigationSn
    },
    irrigatSure() {
      this.irrigationEditor=false
      let option={}
      option.deviceType='irrigate'
      option.parkId=this.parkId
      option.sn=this.irrigationSn
      option.id= this.equipSn.irrId
      if(this.irrigationSnSet){
        setParkDeviceSn(option).then(data=>{
          this.parkDiviceInfoget()
          this.$message.success(data.message)
        })
      }else{
        updateParkDeviceSn(option).then(data=>{
          this.parkDiviceInfoget()
          this.$message.success(data.message)
        })
      }
    },
    irrigatCancel() {
      this.irrigationEditor=false
    },
    equipHighlight(e) {
      e.highlight = true
    },
    toAddDevice() {
      this.$router.push('equip-editor')
    },
    equipsDataGet() {
      getDevicesByParkId(this.parkId).then((data) => {
        this.equips = data.data
        this.equips.forEach((item)=>{
          item.parkId=this.parkId
        })
      })
    },
    //园区下拉选项
    parkOptionGet() {
      getParksInEnterprise(this.$store.getters.currentEnterprise.id).then(
        (data) => {
          this.parkOption = data.data
        }
      )
    },
  },
}
</script>
<style scoped>
#filter .el-col {
  padding: 5px 0;
}
  .title-font{
    font-size: 14px;
  }
  .content-font{
    font-size: 13px;
    color: #6f6f6f;
  }
</style>



// WEBPACK FOOTER //
// src/components/resource/equip/Index.vue